function waitForConditions(
  conditionFunc,
  callback,
  timeout = 3000,
  interval = 100
) {
  let elapsedTime = 0;

  const intervalId = setInterval(() => {
    if (conditionFunc()) {
      clearInterval(intervalId);
      callback();
    } else if (elapsedTime >= timeout) {
      clearInterval(intervalId);
      console.error("Condition was not met within the timeout period");
    }
    elapsedTime += interval;
  }, interval);
}

document.addEventListener("DOMContentLoaded", () => {
  function updateFixedBar() {
    let scrollPosition = window.scrollY;
    let windowWidth = window.innerWidth;
    const fixedBar = document.querySelector(".fixed-bottom-bar");
    const productDetailsSection = document.querySelector("#cwr-product-details");

    // Get the position of the #cwr-product-details section
    const productDetailsPosition = productDetailsSection.getBoundingClientRect();

    // Check if the user is within the #cwr-product-details section
    const isInProductDetails = productDetailsPosition.top < window.innerHeight && productDetailsPosition.bottom > 0;

    if (scrollPosition > 600 && windowWidth < 768 && !isInProductDetails) {
      fixedBar.style.cssText = "transform: translateY(0); visibility: visible;";
    } else {
      fixedBar.style.transform = "translateY(100%)";
    }
  }

  updateFixedBar();
  window.addEventListener("scroll", updateFixedBar);

  const conditionFunc = () => document.getElementById("chat-button") !== null;

  const handleChatButton = () => {
    const chatButton = document.getElementById("chat-button");

    function updateChatButton() {
      let scrollPosition = window.scrollY;
      let windowWidth = window.innerWidth;

      if (scrollPosition > 600 && windowWidth < 768) {
        chatButton.style.transform = "translateY(-82px)";
      } else {
        chatButton.style.transform = "translateY(0)";
      }
    }

    updateChatButton();
    window.addEventListener("scroll", updateChatButton);
  };

  waitForConditions(conditionFunc, handleChatButton);
});